import a from "./index439.js";
import { resolveComponent as t, createElementBlock as n, openBlock as o, createBlock as s, createCommentVNode as p, toDisplayString as m } from "vue";
import l from "./index231.js";
const i = ["data-component"], d = {
  key: 2,
  class: "ml-4"
};
function _(e, f, u, g, h, k) {
  const c = t("LocatedSvg"), r = t("ms-locator");
  return o(), n("div", {
    class: "relative flex items-center h-full px-16 cursor-pointer screen-m:px-24 screen-l:px-0",
    "data-component": e.$options.name
  }, [
    e.isLocated() ? (o(), s(c, {
      key: 0,
      class: "w-[34px] h-[34px]"
    })) : (o(), s(r, {
      key: 1,
      class: "w-24 h-24"
    })),
    e.isScreenL && e.isLocated() ? (o(), n("span", d, m(e.getLocationName()), 1)) : p("", !0)
  ], 8, i);
}
const x = /* @__PURE__ */ l(a, [["render", _]]);
export {
  x as default
};
